import React, { useEffect } from "react";
import styled from "styled-components";
import Gettext from "../common/Gettext";
import { fontSize } from "../common/styled-mixins";
import CloseIcon from "../Icons/Close";
import { TradeThemeProvider } from "../ThemeProvider";

import * as S from "../Trade/StockClose";

import iconAlert from "../../images/BehaviourTriggers/alert.png";

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 20003;
`;

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 740px;
  padding: 40px 35px 32px;
  color: ${({ theme }) => (theme.mode === "light" ? "#919191" : "#CCCCCC")};
  background-color: ${({ theme }) =>
    theme.mode === "light" ? "#F5F5F5" : "#272B34"};
  border-radius: 4px;
  text-align: center;

  @media (max-width: 959px) {
    top: 0;
    left: 0;
    transform: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 32px 16px 38px;
    border-radius: 0;
  }

  @media (max-height: 500px) {
    overflow-y: auto;
    position: relative;
    justify-content: space-around;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 19px;
  right: 19px;
  display: block;
  width: 20px;
  height: 20px;
  padding: 0;
  color: #717171;
  background: transparent;
  border: none;
  cursor: pointer;
`;

const Title = styled.div`
  font-size: ${fontSize(28)};
  line-height: 1.5;
  color: ${({ theme }) => (theme.mode === "light" ? "#0085EB" : "#FFCC00")};
  font-weight: 700;
  margin-bottom: 19px;
`;

const Text = styled.div`
  font-size: ${fontSize(14)};
  line-height: 1.7;
  color: ${({ theme }) => (theme.mode === "light" ? "#919191" : "#CCCCCC")};
  max-width: 280px;
  margin: 0 auto;
`;

const Icon = styled.img`
  margin: 0 auto 22px;

  @media (max-height: 500px) {
    display: none;
  }
`;

const ButtonBlock = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 73px;
  @media (max-height: 500px) {
    margin-top: 20px;
  }
`;

const Button = styled.button`
  position: relative;
  min-width: 140px;
  padding: 12px 36px;
  font-weight: bold;
  font-size: ${fontSize(12)};
  color: #ffffff;
  text-decoration: none;
  text-transform: uppercase;
  background-image: linear-gradient(to right, #47c0c8 0%, #5c6cc0 100%);
  border: none;
  border-radius: 32px;
  cursor: pointer;
  z-index: 2;

  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: block;
    background-image: linear-gradient(to right, #5c6cc0 0%, #47c0c8 100%);
    border-radius: inherit;
    z-index: -1;
    opacity: 0;
    transition: opacity 0.5s;
  }

  :hover::before {
    opacity: 1;
  }
`;

const BehaviourTriggersPopup = props => {
  useEffect(() => () => props.dismissTriggerPopup(), []);

  return (
    <TradeThemeProvider>
      <Wrapper>
        <Overlay onClick={props.onDismiss} />
        <Container>
          <CloseButton onClick={props.onDismiss}>
            <CloseIcon />
          </CloseButton>

          <Icon src={iconAlert} />

          {false && (
            <Title>
              <Gettext>Hint:</Gettext>
            </Title>
          )}

          <Text>{props.text}</Text>

          {props.recommendations && props.recommendations.length && (
            <React.Fragment>
              <Text>
                <Gettext>You can use the following assets</Gettext>:
              </Text>
              <S.StocksTable>
                {props.recommendations.map(stock => (
                  <S.Stock
                    key={stock.stock}
                    onClick={() => {
                      if (typeof props.onStockClick === "function") {
                        props.onStockClick(stock.stock);
                      }
                      props.onDismiss();
                    }}
                  >
                    <S.StockCategory>
                      {stock.category.toUpperCase().replace("_OTC", "")}
                    </S.StockCategory>
                    <S.StockName>{stock.stock.replace("_OTC", "")}</S.StockName>
                    {stock.otc ? <S.OtcImage /> : <S.Otc />}
                    <S.StockPercent>
                      {props.activeAccount.type === "real"
                        ? `${stock.realProfit}%`
                        : `${stock.demoProfit}%`}
                    </S.StockPercent>
                  </S.Stock>
                ))}
              </S.StocksTable>
            </React.Fragment>
          )}

          {(!props.recommendations || !props.recommendations.length) && (
            <ButtonBlock>
              <Button onClick={props.onDismiss}>
                <Gettext>OK</Gettext>
              </Button>
            </ButtonBlock>
          )}
        </Container>
      </Wrapper>
    </TradeThemeProvider>
  );
};

export default BehaviourTriggersPopup;



// WEBPACK FOOTER //
// ./src/components/TradeModals/BehaviourTriggersPopup.js